import React, { FC, ReactNode } from 'react';

import classes from './SEOCopyParagraph.module.scss';

export type SEOCopyParagraphProps = {
  title?: string;
  bodyText?: ReactNode;
};

export const SEOCopyParagraph: FC<SEOCopyParagraphProps> = ({ title, bodyText }) =>
  title || bodyText ? (
    <section className={classes.root}>
      {title && (
        <header>
          <h4 className={classes.title}>{title}</h4>
        </header>
      )}
      {bodyText && <div className={classes.text}>{bodyText}</div>}
    </section>
  ) : null;
